if (!customElements.get("custom-featured-nav")) {
  customElements.define(
    "custom-featured-nav",
    class CustomFeaturedNav extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.scrollableElement = this.querySelector(".secondary-navigation");
        this.container = this.querySelector(".custom-featured-nav-plp");
        this.currentActiveChild = this.querySelector(
          ".custom-nav__button--active",
        );
        this.prevButton = this.querySelector(".secondary-navigation__prev");
        this.nextButton = this.querySelector(".secondary-navigation__next");

        this.checkScroll = this.checkScroll.bind(this);

        this.scrollPrev = this.scrollPrev.bind(this);
        this.scrollNext = this.scrollNext.bind(this);

        this.setScrollableElementPosition =
          this.setScrollableElementPosition.bind(this);

        if (this.scrollableElement && this.container) {
          this.scrollableElement.addEventListener("scroll", this.checkScroll);
        }

        if (this.prevButton && this.nextButton) {
          this.prevButton.addEventListener("click", this.scrollPrev);
          this.nextButton.addEventListener("click", this.scrollNext);
          window.addEventListener("resize", this.checkScroll);
        }
        this.setScrollableElementPosition();
      }

      scrollPrev() {
        this.scrollableElement.scrollTo({
          left: 0,
          top: 0,
          behavior: "smooth",
        });
      }

      scrollNext() {
        this.scrollableElement.scrollTo({
          left: this.scrollableElement.scrollWidth,
          top: 0,
          behavior: "smooth",
        });
      }

      setScrollableElementPosition() {
        if (this.scrollableElement && this.currentActiveChild) {
          const scrollableRect = this.scrollableElement.getBoundingClientRect();
          const childRect = this.currentActiveChild.getBoundingClientRect();
          const relativeLeft = childRect.left - scrollableRect.left;
          this.scrollableElement.scrollTo({
            left: relativeLeft - 22,
            top: 0,
            behavior: "smooth",
          });
        }
      }

      checkScroll() {
        if (
          this.scrollableElement.scrollWidth -
            this.scrollableElement.clientWidth ===
          this.scrollableElement.scrollLeft
        ) {
          // Scrolled to the right
          this.container.classList.add("at-max-scroll");
          if (this.nextButton) this.nextButton.classList.add("hidden");
        } else {
          // Not scrolled to the right
          this.container.classList.remove("at-max-scroll");
          if (this.nextButton) this.nextButton.classList.remove("hidden");
        }

        // Check if scrolled from the left
        if (this.scrollableElement.scrollLeft > 0) {
          this.container.classList.add("not-at-min-scroll");
          if (this.prevButton) this.prevButton.classList.remove("hidden");
        } else {
          this.container.classList.remove("not-at-min-scroll");
          if (this.prevButton) this.prevButton.classList.add("hidden");
        }
      }

      disconnectedCallback() {
        if (this.scrollableElement && this.container) {
          this.scrollableElement.removeEventListener(
            "scroll",
            this.checkScroll,
          );
        }
      }
    },
  );
}
